import { useQuery } from '@tanstack/react-query'
import { httpClient } from '@/shared/lib/httpClient'
import { apiV1 } from '@/shared/api/apiPrefix'
import {
  urgentMessagesResponseSchema,
  type UrgentMessage,
} from '@/shared/schemas/urgentMessage.schema'

export const urgentMessagesKeys = {
  all: ['urgent-messages'] as const,
  active: () => [...urgentMessagesKeys.all, 'active'] as const,
}

/** Communications urgentes actives (bandeaux), source serveur (RV-31). */
export function useUrgentMessages() {
  return useQuery({
    queryKey: urgentMessagesKeys.active(),
    queryFn: async (): Promise<UrgentMessage[]> => {
      const res = await httpClient.get<unknown>(apiV1('/urgent-messages'))
      return urgentMessagesResponseSchema.parse(res.data).data.items
    },
    // Volatile: refléter vite une comm urgente publiée côté admin.
    staleTime: 30_000,
  })
}
